'use client'; import React from 'react';
import { motion } from 'framer-motion';

const PageBanner = ({
    title,
    description,
    bgColor = "#F9FAFB",
    blobColors = ["var(--color-brand-100)", "var(--color-brand-50)", "var(--color-brand-200)"],
    children
}) => {
    return (
        <div className="py-16 relative w-full h-[350px] md:h-[450px] flex items-center justify-center overflow-hidden bg-white overflow-visible">
            {/* Background elements (Untitled UI style) */}
            <div className="absolute inset-0 z-0 bg-white">
                <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none"
                    style={{ backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)', backgroundSize: '32px 32px' }} />

                <div
                    className="absolute top-[-20%] right-[-10%] w-[50%] h-[80%] rounded-full mix-blend-multiply filter blur-[100px] opacity-40 animate-blob"
                    style={{ backgroundColor: blobColors[0] }}
                />
                <div
                    className="absolute bottom-[10%] left-[-5%] w-[50%] h-[80%] rounded-full mix-blend-multiply filter blur-[100px] opacity-40 animate-blob animation-delay-2000"
                    style={{ backgroundColor: blobColors[2] }}
                />
            </div>

            <div className="relative z-10 container mx-auto px-4 text-center">
                <motion.h1
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                    className="text-display-lg md:text-display-xl font-semibold text-gray-900 mb-6 tracking-tight"
                >
                    {title}
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                    className="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto mb-10"
                >
                    {description}
                </motion.p>

                {children && (
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.6 }}
                    >
                        {children}
                    </motion.div>
                )}
            </div>
        </div>
    );
};

export default PageBanner;
